export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8025.0b21a531.jpg";